<template>
  <div>
    <v-container
      ><v-row
        ><v-col cols="0" lg="0" xl="1"></v-col
        ><v-col cols="12" lg="12" xl="10">
          <v-img
            max-width="100%"
            lazy-src="https://unilife.pec.com.tw/terms-and-policy.jpg"
            src="https://unilife.pec.com.tw/terms-and-policy.jpg"
          ></v-img>
          <div class="d-flex footer-line mb-4">
            <div class="primary" style="height: 6px; width: 50vw"></div>
            <div class="warning" style="height: 6px; width: 25vw"></div>
            <div
              class="secondary"
              style="height: 6px; width: 25vw"
            ></div></div></v-col
        ><v-col cols="0" lg="0" xl="1"></v-col
      ></v-row>
      <v-row>
        <v-col cols="0" lg="0" xl="2"></v-col>
        <v-col cols="12" lg="12" xl="8">
          <div class="px-4">
            <h3
              class="text-center text-h4 mt-0 mt-xl-14 mb-6 font-weight-black"
            >
              個人隱私保密政策
            </h3>
            <p
              class="text-center mb-16 text-subtitle-1 font-italic font-weight-medium"
            >
              歡迎使用「統一企業集團特約商店」（以下簡稱本APP），為了讓您能夠安心的使用本APP的各項服務與資訊，特此向您說明本APP的隱私權保護政策，請詳閱下列內容：
            </p>
            <h6 class="text-h6 mb-2 font-weight-bold">
              一、隱私權保護政策的適用範圍
            </h6>
            <p class="pl-8">
              隱私權保護政策內容，包括本APP如何處理在您使用APP服務時收集到的個人識別資料。隱私權保護政策不適用於本APP以外的相關連結APP，也不適用於非本APP所委託或參與管理的人員。本APP的頁面提供其他網站的網路連結，您也可經由本APP所提供的連結，點選進入其他網站。但該連結網站不適用本APP的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。
            </p>
            <h6 class="text-h6 mb-2 font-weight-bold">
              二、個人資料的蒐集、處理及利用方式
            </h6>
            <ul class="mb-4 pl-12">
              <li>
                當您造訪本APP或使用本APP所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內蒐集、處理及利用您的個人資料；非經您書面同意，本APP不會將個人資料用於其他用途。
              </li>
              <li>
                於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的裝置、瀏覽及點選資料記錄等，做為我們增進APP服務的參考依據，此記錄僅為內部應用不對外公佈。
              </li>
            </ul>
            <h6 class="text-h6 mb-2 font-weight-bold">
              三、與第三人共用個人資料之政策
            </h6>
            <p class="pl-8">
              本APP不會提供您的個人資料給其他第三人，但有法律依據、與第三人存有合約義務或以下情事者，不在此限。
            </p>
            <p class="pl-8">前項但書之情形包括不限於：</p>
            <ul class="mb-4 pl-12">
              <li>經由您同意。</li>
              <li>有利於您的權益。</li>
              <li>為免除您生命、身體、自由或財產上之危險。</li>
              <li>
                與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。
              </li>
              <li>
                當您在APP的行為，違反服務條款或可能損害或妨礙APP與其他使用者權益或導致任何人遭受損害時，揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。
              </li>
            </ul>
            <h6 class="text-h6 mb-2 font-weight-bold">
              四、隱私權保護政策之修正
            </h6>
            <p class="pl-8">
              本APP隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於APP上。
            </p>
            <h6 class="text-h6 mb-2 font-weight-bold">五、個資蒐集告知事項</h6>
            <p class="pl-8">
              本APP絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。
            </p>
            <p class="pl-8 font-weight-bold">前項但書之情形包括不限於：</p>
            <ul class="mb-4 pl-12">
              <li>
                告知事項：依據個人資料保護法等相關規定，統一友友旅行社股份有限公司明列以下告知事項：
                <ol class="mt-4 mb-4 pl-12">
                  <li>蒐集個人資料公司：統一友友旅行社股份有限公司。</li>
                  <li>
                    蒐集之目的：註冊管理、行銷分析、識別統一企業集團之員工，及享個人優惠福利之用。
                  </li>
                  <li>
                    個人資料之類別：姓名、員工編號、性別、照片、出生年月日、聯絡方式。
                  </li>
                  <li>
                    個人資料利用之期間：利用之期間至統一友友旅行社股份有限公司與台端之雇主簽訂之本APP服務合約期滿或您提出停止使用或刪除資料為止。
                  </li>
                  <li>個人資料利用之對象：統一友友旅行社股份有限公司。</li>
                  <li>
                    個人資料利用之地區：統一友友旅行社股份有限公司之營運範圍，惟不會做境外傳輸或移轉至其他境外地區利用。
                  </li>
                  <li>
                    個人資料利用之方法：APP、網際網路、電子郵件、書面及傳真等。
                  </li>
                  <li>
                    台端依個人資料保護法第三條規定得行使之權利及方式：得透過統一友友旅行社進行查詢、閱覽、下載複製本、補充或更正內容；有關請求停止蒐集、處理、利用或刪除，於非假日時間聯絡「本APP」管理人員，週一至週五8:00~17:00，請洽06-2536789轉分機8017，或寄e-mail至schuan@mail.pec.com.tw。
                  </li>
                  <li>
                    此外，台端可自行決定提供個人資料，若台端選擇不提供，或事後請求刪除、停止蒐集、處理、利用個人資料時，將可能無法使用本APP。
                  </li>
                </ol>
              </li>
              <li>
                台端同意保證登錄之個人資料，絕無擅自利用他人名義或為不實之提供；若故意提供虛偽之個人資料而造成他人之損害時，必須自行負擔相關之民、刑事責任；若因而導致統一友友旅行社股份有限公司之損害，並應負相關之責任。
              </li>
              <li>
                台端瞭解並同意不將密碼洩漏、交付、出借、轉讓予第三人；若因台端之疏忽，造成個人資料外洩、變造，或為其他不法之利用，其結果應由台端自行承擔。
              </li>
              <li>
                台端於本APP填寫或提供上述個人資料時，均視為已同意提供該資料予「統一友友旅行社股份有限公司」於蒐集之目的範圍內處理及利用。
              </li>
            </ul>
          </div></v-col
        >
        <v-col cols="0" lg="0" xl="2"></v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style>
p {
  line-height: 1.6;
}
ul li {
  line-height: 1.6;
  margin-bottom: 8px;
}
</style>
